import { useEffect, useState } from "react";
import { fetchDataStart } from "../../../../modules/reducers/chat/agent/getSendbirdStatus";

import { getSendbirdStatusApi } from "../../../../api/sendbird/getSendbirdStatusApi";
import {
  handleServiceDown,
  handleServiceUp,
} from "../../api/agent/handleService";
import { useGroupChannelContext } from "@sendbird/uikit-react/GroupChannel/context";
import {
  sendbirdSelectors,
  useSendbirdStateContext,
} from "@sendbird/uikit-react";
import { useDispatch, useSelector } from "react-redux";

import {
  serviceDown,
  serviceUp,
} from "../../../../modules/reducers/handleService";
import erody from "../../../../assets/erody_chat.svg";
import { fileUploadSet } from "../../../../modules/reducers/chat/agent/fileUpload";
import useReactGASend from "../../../../hooks/useReactGASend";
import { useNavigate } from "react-router-dom";

const useMessageControl = ({ closeModal, setIsLoadingModalOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { messages, deleteMessage, channelUrl, channel, loadNext, hasNext } =
    useGroupChannelContext();
  const [reOrderdMap, setReOrderdMap] = useState([]);
  const [messageMap, setMessageMap] = useState(null);
  const [ticketClose, setTicketclose] = useState(false);
  const [isOnline, setisOnline] = useState();
  const [assigned, setAssigned] = useState(false);
  const [delayed, setDelayed] = useState({ delayed: false, message: "" });
  const [closedForCall, setClosedForCall] = useState({
    closedForCall: false,
    message: "",
  });
  const [closedbyAgent, setClosedbyAgent] = useState({
    closedbyAgent: false,
    message: "",
  });
  const [isOperating, setIsOperating] = useState({
    isOperating: true,
    message: "",
  });
  const [transferNumber, setTransferNumber] = useState(null);
  const [survey, setSurvey] = useState(false);
  const [eventTrack, setEventTrack] = useState(null);

  const globalStore = useSendbirdStateContext();
  const sdkInstance = sendbirdSelectors.getSdk(globalStore);
  const userId = useSelector((state) => state.checkArsStatus.userId);
  const arsAgentId = useSelector((state) => state.connectChatServer.arsAgentId);
  const [eventTracked, setEventTracked] = useState(false); // 이벤트 추적 여부 플래그 추가

  // sendbird 상태에 장애 페이지 이돌 로직
  const status = useSelector((state) => state.getSendbirdStatus.status);
  const errorType = useSelector((state) => state.getSendbirdStatus.errorType);
  const unavailableCount = useSelector((state) => state.getSendbirdStatus.unavailableCount);

  const { makeEventTrackFn } = useReactGASend();
  const addOperator = async () => {
    //channel에 operator 추가 (메시지 삭제를 위해서 필요함)
    try {
      const groupChannel = await channel?.getChannel(channelUrl);
      await groupChannel?.addOperators([userId]);
      // console.log("User added as operator successfully");
    } catch (error) {
      // console.error("Error adding operator:", error);
    }
  };

  useEffect(() => {
    if (hasNext()) {
      loadNext();
    }
  }, [messages]);

  const handleDeleteMessage = ({ messageId }) => {
    // 메시지 삭제 함수
    const message = reOrderdMap.find(
      (message) => message.messageId === messageId
    );
    deleteMessage(message)
      .then(() => {
        console.log("Message deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting message:", error);
      });
  };

  const sortMessages = (messages) => {
    return messages.sort((a, b) => {      
      // 1. customType이 있으면 우선 사용
      const typeA = parseInt(a.customType);
      const typeB = parseInt(b.customType);
      
      if (!isNaN(typeA) && !isNaN(typeB)) {
        return typeA - typeB;
      }
      
      // 2. createdAt 기준 정렬 
      if (a.createdAt && b.createdAt) {
        return a.createdAt - b.createdAt;
      }
      
      // 3. messageId 기준 정렬
      const idA = String(a.messageId || '');
      const idB = String(b.messageId || '');
      return idA.localeCompare(idB);
    });
  };

  useEffect(() => {
    setReOrderdMap(sortMessages(messages));
    // console.log(messages);
  }, [messages]);

  useEffect(() => {
    if (eventTrack && !eventTracked) {
      makeEventTrackFn(eventTrack);
      setEventTracked(true);
    }
  }, [eventTrack, eventTracked, makeEventTrackFn]);
  useEffect(() => {
    addOperator();
  }, []);

  useEffect(() => {
    if (assigned) {
      closeModal(setIsLoadingModalOpen);
    }
  }, [assigned]);

  useEffect(() => {
    const sendbirdOnline = async () => {
      const status = await sdkInstance._onlineDetector?.isOnline();
      setisOnline(status);
    };
    sendbirdOnline();
  }, [globalStore]);

  useEffect(() => {
    const api = getSendbirdStatusApi();
    const status = setInterval(() => {
      dispatch(fetchDataStart(api));
    }, 20000);
    return () => {
      clearInterval(status);
    };
  }, []);

  useEffect(() => {
    const status = setInterval(() => {
      if (isOnline) {
        dispatch(serviceUp(handleServiceUp));
        // console.log(isOnline);
      } else {
        dispatch(serviceDown(handleServiceDown));
        // console.log(isOnline);
      }
    }, 20000);
    return () => {
      clearInterval(status);
    };
  }, [isOnline]);

  useEffect(() => {
    // 메시지 배열에서 뺄 시스템 메시지
    const excludeTypes = [
      "NOTIFICATION_ASSIGNMENT_DELAY",
      "SYSTEM_MESSAGE_TICKET_CLOSED_BY_AGENT",
      "NOTIFICATION_MANUAL_CLOSED",
      "NOTIFICATION_NOT_OPERATING_HOUR",
    ];
    let transferToCall = false;
    reOrderdMap?.forEach((msg) => {
      const data = JSON.parse(msg.data || "{}");
      if (
        data?.type === "SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_AGENT" ||
        data?.type === "SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_PLATFORM_API"
      ) {
        transferToCall = true;
      }
    });

    const processedMessage = reOrderdMap?.map((msg) => {
      let {
        data,
        message,
        sender,
        createdAt,
        ogMetaData,
        type,
        requireAuth,
        messageId,
        url,
      } = msg;
      const userId = sender?.userId || "";
      const plainProfileUrl = sender?.plainProfileUrl || "";
      sender = sender || "";

      function parsing(data) {
        let parsedData;
        try {
          parsedData = JSON.parse(data);
          if (typeof parsedData === "number") {
            parsedData = data;
          }
        } catch (e) {
          parsedData = data;
        }
        return parsedData;
      }

      message = parsing(message);
      data = parsing(data);
      if (data?.type === "SYSTEM_MESSAGE_TICKET_ACTIVE_TO_IDLE_BY_SYSTEM") {
      } else if (data?.type === "NOTIFICATION_ASSIGNMENT_DELAY") {
        setDelayed({ delayed: true, message: message });
      } else if (
        [
          "SYSTEM_MESSAGE_TICKET_ASSIGNED_BY_AGENT",
          "SYSTEM_MESSAGE_TICKET_ASSIGNED_BY_PLATFORM_API",
          "SYSTEM_MESSAGE_TICKET_ASSIGNED_BY_SYSTEM",
        ].includes(data?.type)
      ) {
        setAssigned(true);
      } else if (
        data?.type === "SYSTEM_MESSAGE_TICKET_IDLE_TO_ACTIVE_BY_CUSTOMER"
      ) {
      } else if (data?.type === "SYSTEM_MESSAGE_TICKET_CLOSED_BY_SYSTEM") {
        setTicketclose(true);
        setSurvey(false);
        setClosedbyAgent({
          closedbyAgent: true,
          message,
        });
        setEventTrack({
          category: "event",
          action: "상담종료(시스템)",
        });
      } else if (
        [
          "SYSTEM_MESSAGE_TICKET_CLOSED_BY_AGENT",
          "SYSTEM_MESSAGE_TICKET_CLOSED_BY_PLATFORM_API",
        ].includes(data?.type)
      ) {
        //상담사 종료
        setTicketclose(true);
        setSurvey(true);
        setClosedbyAgent({
          closedbyAgent: true,
          message,
        });
        setEventTrack({
          category: "event",
          action: "상담종료(상담사)",
        });
      } else if (data?.type === "NOTIFICATION_MANUAL_CLOSED") {
        //"SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_AGENT"랑 중복 실행됨
        //상담사 종료
        setTicketclose(true);
        setSurvey(true);
        setClosedbyAgent({
          closedbyAgent: true,
          message,
        });
      } else if (
        [
          "SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_PLATFORM_API",
          "SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_AGENT",
        ].includes(data?.type)
      ) {
        if (data?.transfer?.memo) {
          const { memo } = data.transfer;
          const { id } = data.ticket?.recentAssignment?.agent;
          if (id === arsAgentId) {
            excludeTypes.push(
              "SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_PLATFORM_API"
            );
            excludeTypes.push("SYSTEM_MESSAGE_TICKET_TRANSFERRED_BY_AGENT");

            setTransferNumber(memo);

            setClosedForCall({
              closedForCall: true,
              message: "채팅이 종료되었습니다. 음성 상담원 연결을 눌러주세요.",
            });

            //음성 이관
            setTicketclose(true);
            setSurvey(false);
          }
        }
      } else if (data?.type === "NOTIFICATION_NOT_OPERATING_HOUR") {
        setIsOperating({ isOperating: false, message });
      }

      return {
        data,
        message,
        sender,
        createdAt,
        ogMetaData,
        type,
        requireAuth,
        messageId,
        url,
      };
    });

    if (transferToCall) {
      setSurvey(false);
    }

    const getMesgAndBtns = (content, type, sender, filetype) => {
      let message_ = "";
      let buttons = [];
      let type_ = type;
      let sender_ = sender;
      if (filetype) {
        type_ = filetype;
      }
      const textItem = content?.find((item) => item.type === "text");
      const cardItem = content?.find((item) => item.type === "card");

      if (textItem) {
        message_ = textItem.value;
      } else if (cardItem) {
        const textCard = cardItem.value.find((card) => card.type === "text");
        const systemMessageCard = cardItem.value.find(
          (card) => card.type === "systemMessage"
        );
        if (textCard) {
          message_ = textCard.value;
        } else if (systemMessageCard) {
          message_ = systemMessageCard.value;
        }
      }

      if (type_ === "INTRO_MESG" || type_ === "BOT") {
        // TODO
        sender_ = {
          userId: "erody",
          plainProfileUrl: erody,
          nickname: "이로디",
          type: type_,
        };
      }
      return { type: type_, message: message_, buttons, sender: sender_ };
    };

    const makeCard = ({ data, message }) => {
      let card = [];
      if (!data.type) {
        //타입이 있는것은 시스템 메시지
        if (message?.content) {
          message.content?.map((item) => {
            if (item.type === "text") {
              card.push({
                type: "card",
                value: [
                  {
                    type: "text",
                    value: item.value,
                  },
                ],
              });
            } else if (item.type === "card") {
              card.push(item);
            }
          });
        } else if (typeof message === "string" || typeof message === "number") {
          card.push({
            type: "card",
            value: [
              {
                type: "text",
                value: message,
              },
            ],
          });
        }
      } else {
        card.push({
          type: "card",
          value: [
            {
              type: "systemMessage",
              value: message,
            },
          ],
        });
      }
      if (message?.type === "DIALOG_FLOW_EVENT") {
        card.push({
          type: "card",
          value: [
            {
              type: "text",
              value: message.message,
            },
          ],
        });
      }
      return card;
    };

    // 파일 업로드 활성화 (messages 배열의 마지막 항목 확인 및 처리)
    const lastMessage = reOrderdMap[reOrderdMap?.length - 1];
    if (lastMessage) {
      function parsing(data) {
        let parsedData;
        try {
          parsedData = JSON.parse(data);
        } catch (e) {
          parsedData = data;
        }
        return parsedData;
      }

      const parsedData = parsing(lastMessage.message || "{}");
      const lastContent = parsedData.content;
      if (Array.isArray(lastContent)) {
        lastContent.forEach((item) => {
          if (item.type === "card") {
            item.value.forEach((valueItem) => {
              if (valueItem.type === "buttons" && valueItem.value) {
                valueItem.value.forEach((button) => {
                  console.log("lastContent", button);
                  if (button.action === "file") {
                    dispatch(fileUploadSet({ canFileSend: true }));
                  }
                });
              }
            });
          }
        });
      }
    }

    const formattedMessages = processedMessage
      .filter(
        (msg) =>
          !excludeTypes.includes(msg.data?.type) &&
          msg.message?.type !== "GREET_RESPOND_NORMAL"
      )
      .map(
        ({
          data,
          message,
          sender,
          createdAt,
          ogMetaData,
          type: fileType,
          requireAuth,
          messageId,
          url,
        }) => {
          const card = makeCard({ data, message });
          const {
            type,
            message: formattedMessage,
            buttons,
            sender: sender_,
          } = getMesgAndBtns(
            card,
            data?.type || message?.type,
            sender,
            fileType
          );

          return {
            type,
            data: data,
            card,
            sender: sender_,
            message: formattedMessage,
            buttons,
            createdAt,
            ogMetaData,
            requireAuth,
            messageId,
            url,
          };
        }
      );

    setMessageMap(formattedMessages);
  }, [reOrderdMap]);

  useEffect(() => {
    if (status) {
      if (status === "unavailable") {
        makeEventTrackFn({ category: "event", action: `${errorType}-${unavailableCount}` });
      } 
    }
  }, [unavailableCount]);

  return {
    messageMap,
    userId,
    delayed,
    transferNumber,
    ticketClose,
    survey,
    closedForCall,
    closedbyAgent,
    isOperating,
    handleDeleteMessage,
    messages
  };
};

export default useMessageControl;
